import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { Button } from 'web-ui-components/lib/atoms/buttons';

const Processed = ({ onClose, processedHeaderText, processedSubHeaderText, processedButtonText }) => (
	<div>
		<div className="u-flex u-flex-justify-content-center">
			<Icon iconType="TickOutlineCircleFilledLarge" size={100} />
		</div>
		<h2>{processedHeaderText}</h2>

		<p>{processedSubHeaderText}</p>
		<Button id="processed-close-button" display="primary" width="full" onClick={onClose}>
			{processedButtonText}
		</Button>
	</div>
);

Processed.propTypes = {
	onClose: PropTypes.func.isRequired,
	processedHeaderText: PropTypes.string.isRequired,
	processedSubHeaderText: PropTypes.string.isRequired,
	processedButtonText: PropTypes.string.isRequired,
};

export default Processed;
